export default {"src":"/_next/static/media/v1_phregister.f4f62d57.svg","height":694,"width":594,"blurWidth":0,"blurHeight":0};